<template>
    <div>
        <div class="filters">
            <div class="filter">
                <span class="filter-name">상품타입: </span>
                <el-select class="medium-filter"
                           v-model="types"
                           multiple
                           placeholder="타입 다중 선택">
                    <el-option v-for="item in productTypes"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="filter">
                <span class="filter-name">태그: </span>
                <el-input class="small-filter"
                          placeholder="완전 일치하는 태그만"
                          v-model="query"
                          maxlength="20"
                          show-word-limit>
                </el-input>
            </div>
        </div>
        <div class="filters">
            <div class="filter">
                <span class="filter-name">유저ID: </span>
                <el-input class="small-filter"
                          placeholder="유저ID를 입력하세요."
                          v-model="userId">
                </el-input>
            </div>
            <div class="filter">
                <span class="filter-name">상태: </span>
                <el-select class="mini-filter"
                           v-model="isValid"
                           placeholder="상태를 선택하세요.">
                    <el-option label="전체" :value="null"></el-option>
                    <el-option label="정상" :value="true"></el-option>
                    <el-option label="정지" :value="false"></el-option>
                </el-select>
            </div>
            <div class="filter">
                <span class="filter-name">공개여부: </span>
                <el-select class="mini-filter"
                           v-model="isPublic"
                           placeholder="공개여부를 선택하세요.">
                    <el-option label="전체" :value="null"></el-option>
                    <el-option label="공개" :value="true"></el-option>
                    <el-option label="비공개" :value="false"></el-option>
                </el-select>
            </div>
            <el-button type="primary" size="medium" @click.prevent="changeFilter">검색</el-button>
        </div>
    </div>
</template>

<script>
    import {ART_SET_FILTER} from '@/store/modules/art';
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'ArtListFilter',
        data() {
            return {
                types: [],
                query: null,
                userId: null,
                partnerId: null,
                isValid: null,
                isPublic: null,

                productTypes: [],
            };
        },
        computed: {
            filters() {
                return this.$store.state.art.filters;
            },
        },
        methods: {
            async changeFilter() {
                await this.applyTypesFilter();
                await this.applyFilter('query');
                await this.applyFilter('userId');
                await this.applyIsValidFilter();
                await this.applyIsPublicFilter();
            },
            async applyFilter(key) {
                let value = this[key]?.trim();
                if (!value) {
                    value = null;
                }
                await this.$store.dispatch(ART_SET_FILTER, {key, value});
            },
            async applyTypesFilter() {
                await this.$store.dispatch(ART_SET_FILTER, {key: 'types', value: this.types});
            },
            async applyIsValidFilter() {
                await this.$store.dispatch(ART_SET_FILTER, {key: 'isValid', value: this.isValid});
            },
            async applyIsPublicFilter() {
                await this.$store.dispatch(ART_SET_FILTER, {key: 'isPublic', value: this.isPublic});
            },
            async getProducts() {
                const {data} = await PrintingDiyRepository.getProducts();
                this.productTypes = data.map(type => {
                    return {
                        value: type.productType,
                        label: type.productType,
                    };
                });
            },
        },
        created() {
            this.getProducts();

            this.types = this.filters.types;
            this.query = this.filters.query;
            this.userId = this.filters.userId;
            this.partnerId = this.filters.partnerId;
            this.isValid = this.filters.isValid;
            this.isPublic = this.filters.isPublic;
        },
    };
</script>

<style lang="scss" scoped>

</style>